export default "__VITE_ASSET__3jpLxYOe__"